import { useEffect, useState } from "react";
import { getAllMasterData } from "../services/main-service/mainService";

export function useMasterData() {
  const [masterData, setMasterData] = useState<any | null>(() => {
    const saved = sessionStorage.getItem("masterData");
    return saved ? JSON.parse(saved) : null;
  });

  const [masterDataLoading, setMasterDataLoading] = useState(!masterData);
  const [masterDataError, setMasterDataError] = useState<any>(null);

  const fetchMasterData = async () => {
    try {
      setMasterDataLoading(true);
      setMasterDataError(null);

      const data = await getAllMasterData();

      sessionStorage.setItem("masterData", JSON.stringify(data));
      setMasterData(data);
    } catch (err) {
      console.error("Error fetching master data:", err);
      setMasterDataError(err);
    } finally {
      setMasterDataLoading(false);
    }
  };

  // Auto-fetch only if no session data exists
  useEffect(() => {
    if (!masterData) {
      fetchMasterData();
    }
  }, []);

  return {
    masterData,
    masterDataLoading,
    masterDataError,
    refetch: fetchMasterData,
  };
}
